import { buildQuery } from '~/utils'
import jsonp from 'jsonp'
import api from './API'
import config from '~/config'

export default {
  getRelated({
    url,
    q,
    u_q,
    q_all,
    related = 1,
    pp = 8,
    s_id,
    from_photo = 1,
    more_link,
    more_text = 'イラストを',
    sort = 'dlrank',
  }: any) {
    return new Promise((resolve, reject) => {
      jsonp(`${url}?${buildQuery({
        q,
        u_q,
        q_all,
        related,
        pp,
        s_id,
        from_photo,
        more_link,
        more_text,
        sort,
      })}`, (err: any, data: any) => {
        if (err) {
          reject(err)
        } else {
          resolve(data)
        }
      })
    })
  },

  getPresent() {
    return api.get('https://www.photo-ac.com/ajax/public/list_presents', {
      params: {
        secret: config.photoAPISecret,
      },
    })
  },

  getPresentLink(data: any) {
    const {id, premium_info} = data
    return api.post('https://www.photo-ac.com/ajax/public/present', {
      secret: config.photoAPISecret,
      id,
      action_service: "video",
      premium_info
    })
  },
}
